import { Button, Input, Modal } from '@mui/joy'
import React, { useState, Dispatch, SetStateAction, useEffect } from 'react'
import { BLACK, PRIMARY, WHITE } from '../../../appConstants'
import appError from '../../../appError';

type AddAccessModalProps = {
    setToggleModal: Dispatch<SetStateAction<boolean>>;
    data: any[];
    brand_id: string;
    modal_name: string;
}
const AddAccessModal:React.FC<AddAccessModalProps> = ({
    setToggleModal,
    data,
    brand_id,
    modal_name
}) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [inputToken, setInputToken] = useState<string>('');

    const onChangeHandler = ({ target: { value, name } }: React.ChangeEvent<HTMLInputElement>): void => {
      setInputToken(value);
    }

    const onSubmitHandler = (ag_inputToken: string, ag_brandId: string) => {
        const isTokenExist = data.some((obj: any)=> obj.token_id === ag_inputToken);
        if(isTokenExist){
            appError("Please Enter Unique Token Id");
            return;
        }
        setLoading(true);
        const websiteURL = modal_name === "Seller" ? `https://sellercentral.amazon.com/apps/authorize/consent?application_id=amzn1.sp.solution.42b5e678-7eb8-4101-bbec-c548909ae578&state=amazon_eu_sp_app_one,${ag_brandId},Amazon%20Seller%20API,${ag_inputToken}` : `https://vendorcentral.amazon.com/apps/authorize/consent?application_id=amzn1.sp.solution.42b5e678-7eb8-4101-bbec-c548909ae578&state=amazon_eu_sp_app_one,${brand_id},Amazon%20Vendor%20API,${ag_inputToken}`;
        console.log('-->', websiteURL)
        window.open(websiteURL, '_blank');
        setToggleModal(false);
        setLoading(false);
    }

    const autoGenerateToken = (ag_data: any[]): string => {
        let newToken = "";
      
        while (true) {
          const randomNum = Math.floor(1000 + Math.random() * 9000); 
          newToken = `INFY-${randomNum}`;
      
          const exists = ag_data.some((item) => item.token_id === newToken);
      
          if (!exists) {
            return newToken; // Found unique random token
          }
        }
      };

    useEffect(()=>{
        setInputToken(autoGenerateToken(data));
    },[]);

  return (
    <Modal
        open={true}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        > 
        <div style={{
            height: 400,
            width: 700,
            backgroundColor: WHITE.W_100,
            borderRadius: 18,
            padding: 40,
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            justifyContent: "space-between"
          }}>
            <div className="flex flex-col w-full">
                <div
                  className="self-stretch"
                  style={{
                    color: `${BLACK.B_100}`,
                    fontSize: 16,
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "24px",
                  }}
                >
                  Add {modal_name} 
                </div>
                <div
                  className="self-stetch"
                  style={{
                    color: `${BLACK.B_40}`,
                    fontSize: 12,
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "18px",
                  }}
                >
                  Assign Token ID below
                </div>
              </div>

            <div className="w-[50%] flex flex-col gap-[4px]">
              <div
                className="flex flex-col h-[20px] justify-center self-stretch"
                style={{
                  fontSize: 14,
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "20px",
                  color:"#5B5B5B"

                }}
              >
                Enter Token ID :
              </div>
              <Input
                placeholder="INFY-0000"
                sx={{
                    "--Input-focusedThickness": "0px",
                    width: "340px",
                    height: "40px",
                    backgroundColor: BLACK.B_5
                }}
                name="inputToken"
                value={inputToken}
                onChange={onChangeHandler}
              />
            </div>

            <div className="flex flex-row justify-between mt-10 gap-4">
              <Button
                color="neutral"
                sx={{
                  height: "48px",
                  width: "50%",
                  backgroundColor: BLACK.B_5,
                  color: BLACK.B_100,
                  ":hover": {
                    backgroundColor: BLACK.B_20,
                  },
                }}
                onClick={()=>setToggleModal(false)}
              >
                Cancel
              </Button>
              <Button
                loading={loading}
                onClick={() => onSubmitHandler(inputToken, brand_id)}
                disabled={inputToken?.length === 0}
                sx={{
                  height: "48px",
                  width: "50%",
                  backgroundColor: PRIMARY.P_BLue,
                }}
              >
                Submit
              </Button>
            </div>
        </div>       
      </Modal>
  )
}

export default AddAccessModal